// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__FQkiT","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1wodK"};